import { generateUniqueId } from 'utils/unique-id';

import { removeNulls } from 'utils/Object.utils';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type Expense = {
  id?: string;
  name?: string;
  amount?: number;
  frequency?: string;
  [key: string]: any;
};

export type ExpensesState = Record<string, any>;

export function newExpense(props: Partial<Expense> = {}): Expense {
  return {
    id: generateUniqueId(),
    name: 'Expense name',
    amount: 0,
    frequency: 'weekly',
    ...props,
  };
}

const expenseNames = [
  'Rent',
  'Local Government Rates',
  'Water and Sewerage Rates and Charges',
  'Home and Contents Insurance',
  'Electricity',
  'Gas',
  'Telephone - Fixed and Mobile',
  'Internet',
  'Pay Television',
  'Health Insurance',
  'Life Insurance',
  'Car Registration',
  'Car Insurance',
  'Motoring Organisations',
  'Education - School fees',
  'Child Care Fees',
  'Bank Fees',
];

export const newInitialExpenses = (): ExpensesState => {
  return expenseNames.reduce((acc, name) => {
    const e = newExpense({ name });
    return {
      ...acc,
      [e.id]: e,
    };
  }, {} as ExpensesState);
};

const initialState = newInitialExpenses();

const expensesReducer = (
  state: ExpensesState = initialState,
  action: ReducerAction
): ExpensesState => {
  switch (action.type) {
    case 'EXPENSES_UPDATE': {
      const { expense } = action;
      return {
        ...state,
        [expense.id]: expense,
      };
    }
    case 'EXPENSES_ADD_NEW': {
      const { expense } = action;
      return {
        ...state,
        [expense.id]: expense,
      };
    }
    case 'EXPENSES_DELETE': {
      const { expenseId } = action;
      return removeNulls({
        ...state,
        [expenseId]: null,
      }) as ExpensesState;
    }
    default:
      return state;
  }
};
export default expensesReducer;
